import { BasePackage, Package } from '../models/package';
import { PackageType } from '../models/package-type';
import { dateMapper } from './date.mapper';
import { includedProductMapper } from './included-prouct.mapper';
import { stateMapper } from './state.mapper';

/**
 * Map to short package from dto.
 * @param {object} dto Dto.
 * @returns {BasePackage}
 */
function basePackageFromDto(dto) {
  return new BasePackage({
    id: dto.id,
    name: dto.name,
    description: dto.description,
    price: dto.price ?? 0,
    typeId: dto.type_id,
    type: dto.type,
    expensesAmount: dto.expenses_amount,
    expensesDescription: dto.expenses_description,
    classCategoryId: dto.class_category_id,
  });
}

/**
 * Map to package.
 * @param {object} dto Dto.
 * @returns {Package}
 */
function fromDto(dto) {
  return new Package({
    ...basePackageFromDto(dto),
    includedProducts: dto.included_products
      ? dto.included_products.map(p => includedProductMapper.packageIncludedProductFromDto(p))
      : [],
    code: dto.code,
    optionalProducts: dto.optional_products,
    packageDiscounts: dto.package_discounts ? dto.package_discounts.map(p => ({
      amount: p.amount,
      cutoffCount: p.cutoff_count,
      id: p.id,
      packageId: p.package_id,
    })) : [],
    states: dto.states
      ? dto.states.map(state => stateMapper.fromDto(state))
      : [],
    hasClassProduct: dto.has_class_product,
    editDate: dateMapper.fromDto(dto.edit_date),
    remainingQuantity: dto.remaining_qty,
    isLaminatedCard: dto.is_laminated_card,
    isBestValue: dto.is_best_value,
    retailPrice: dto.retail_price,
    promotionText: dto.promotion_text,
    hasFreeFoodHandlerCard: dto.has_free_food_handler_card ?? false,
  });
}

/**
 * Map to get packages query params dto.
 * @param {object} data Data.
 * @param {PackageType[]} data.packageTypes Package types.
 * @param {boolean} [data.isBuyable] Package types.
 * @param {number} [data.classCategoryId] Class category ID.
 * @param {string} [data.state] State.
 * @returns {object}
 */
function toQueryPackagesDto({
  packageTypes, isBuyable, classCategoryId, state,
}) {
  return {
    product_types: packageTypes.map(packageType => packageType.value),
    buyable: isBuyable,
    class_category_id: classCategoryId,
    state,
  };
}

/**
 * Map v2 packages response from dto.
 * @param {object} dto Dto.
 * @returns {Object.<string, Package[]>}
 */
function fromPackageCategoryWithItemsDto(dto) {
  return Object.keys(dto).reduce((acc, category) => {
    // eslint-disable-next-line no-param-reassign
    acc[category] = dto[category].map(packageDto => fromDto(packageDto));
    return acc;
  }, {});
}

export const packageMapper = {
  fromDto,
  basePackageFromDto,
  toQueryPackagesDto,
  fromPackageCategoryWithItemsDto,
};
